// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fj","advertDetailContacts__header":"c-n_fk"};